import { useFetch } from 'hooks/use-fetch/use-fetch';
import { useQuery } from '@tanstack/react-query';
import { fleetRequestConfig } from 'request-config/fleet/fleet.request-config';
import { UnusedFleetQueryKeys } from '../fleet.props';
import { LookupResponse, ResponseModel } from 'common/interfaces';
import { QueryHookOptions } from 'hooks/react-query/react-query.props';
import { AxiosResponse } from 'axios';

export const useDescriptionChoicesQuery = ({
  options
}: QueryHookOptions<AxiosResponse<ResponseModel<LookupResponse[]>>, ResponseModel<LookupResponse[]>> = {}) => {
  const { fetch } = useFetch<ResponseModel<LookupResponse[]>>({
    loadingKey: 'descriptionChoices',
    ...fleetRequestConfig.descriptionChoices
  });

  const { data, ...restQueryProps } = useQuery({
    queryKey: [UnusedFleetQueryKeys.DescriptionChoices],
    queryFn: () => fetch(),
    ...options
  });

  return {
    descriptionChoicesQuery: data?.data?.data || [],
    ...restQueryProps
  };
};
